import { R } from '@core/utils/r';
// import { SortByOptions, SortByDirections } from '@business/entities/checklist';
import { TaskPriority } from '@business/entities/battle_plan';

export function getPriorityColor(priority: TaskPriority, input = false) {
  switch (priority) {
    case TaskPriority.urgent:
      return 'rgb(245, 0, 0)';
    case TaskPriority.high:
      return 'rgb(255, 204, 0)';
    case TaskPriority.normal:
      return 'rgb(111, 221, 255)';
    case TaskPriority.low:
      return 'rgb(216, 216, 216)';
    case TaskPriority.none:
      return input ? '' : '#00000025';
  }
}

export function getPriorityTitle(priority: TaskPriority) {
  switch (priority) {
    case TaskPriority.urgent:
      return 'Urgent';
    case TaskPriority.high:
      return 'High';
    case TaskPriority.normal:
      return 'Normal';
    case TaskPriority.low:
      return 'Low';
    case TaskPriority.none:
      return 'Clear';
  }
}

export function allPriorities(withClear = false) {
  if (withClear) {
    return [TaskPriority.urgent, TaskPriority.high, TaskPriority.normal, TaskPriority.low, TaskPriority.none];
  }

  return [TaskPriority.urgent, TaskPriority.high, TaskPriority.normal, TaskPriority.low];
}

export function getAllPriorityItems() {
  return R.map(allPriorities(true), p => {
    return { label: getPriorityTitle(p), value: p };
  });
}

// export function getSortByOptionTitle(options: SortByOptions) {
//   switch (options) {
//     case SortByOptions.dueDate:
//       return 'Due Date';
//     case SortByOptions.title:
//       return 'Title';
//     case SortByOptions.dateAdded:
//       return 'Date Added';
//   }
// }

// export function getSortByDirectionTitle(options: SortByDirections) {
//   switch (options) {
//     case SortByDirections.asc:
//       return 'ASC';
//     case SortByDirections.desc:
//       return 'DESC';
//   }
// }

// export function allSortByOptions() {
//   return [SortByOptions.dueDate, SortByOptions.title, SortByOptions.dateAdded];
// }

// export function allSortByDirections() {
//   return [SortByDirections.asc, SortByDirections.desc];
// }

// export function getAllSortByItems() {
//   return R.map(allSortByOptions(), p => {
//     return { label: getSortByOptionTitle(p), value: p };
//   });
// }

// export function getAllSortByDirectionItems() {
//   return R.map(allSortByDirections(), p => {
//     return { label: getSortByDirectionTitle(p), value: p };
//   });
// }
